import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';

import LoadingArea from '~/components/LoadingArea';
import TextField from '~/components/TextField';

import TraitsTable from './TraitsTable';
import styles from './TraitsTable.style';

class TraitsTableManager extends React.Component {
  state = {
    filter: null,
  };

  onChangeFilter = (event) => {
    this.setState({ filter: event.target.value });
  };

  getFilteredTraits = (traits) => {
    const { filter } = this.state;

    if (!filter) return traits;

    const filteredKeys = Object.keys(traits).filter(
      (key) => key.toLowerCase().indexOf(filter.toLowerCase()) !== -1,
    );

    return pick(traits, filteredKeys);
  };

  render() {
    const { filter } = this.state;
    const { classes, className, traits } = this.props;

    const traitsTables = traits.reduce(
      (
        tables,
        { sectionHeader, sectionAdornment, sectionTitle, attributes },
      ) => {
        const tableTraits = this.getFilteredTraits(attributes);
        if (!isEmpty(tableTraits)) {
          return [
            tables,
            <TraitsTable
              key={sectionTitle}
              traits={tableTraits}
              sectionHeader={sectionHeader}
              sectionTitle={sectionTitle}
              sectionAdornment={sectionAdornment}
            />,
          ];
        }
        return tables;
      },
      [],
    );

    return (
      <div className={classnames(className, classes.root)}>
        <div className={classes.header}>
          <h3 className={classes.title}>All details</h3>
          <TextField
            fullWidth
            FormControlProps={{ classes: { root: classes.filterRoot } }}
            className={classes.filter}
            value={filter || ''}
            placeholder="Search by name"
            onChange={this.onChangeFilter}
          />
        </div>
        <LoadingArea
          loading={traits === undefined}
          empty={isEmpty(traitsTables)}>
          {traitsTables}
        </LoadingArea>
      </div>
    );
  }
}

TraitsTableManager.propTypes = {
  classes: PropTypes.object,
  id: PropTypes.string,
  fetch: PropTypes.func,
  traits: PropTypes.array,
  className: PropTypes.string,
};

export default withStyles(styles)(TraitsTableManager);
